export function calculatePercentage(duration, absence) {

        let d = duration
        let a = absence

        let total_duration = a / d * 100

        return isNaN(total_duration) ? 0 : total_duration
}

export function ShowabsenceOrAttendance(attendance, percentage) {
        if (attendance === true) return 100 - percentage
        else return percentage
}

export function AttendanceColors(colors, percentage) {
        if (percentage <= colors.low) return 0
        else if (percentage <= colors.medium) return 1
        else if (percentage <= colors.high) return 2
        else return 3
}